import React, { Component } from 'react';
import './App.css';
import Home from './components/Home';

import { Route, Switch } from 'react-router-dom';
import Orders from './components/admin/Orders';
import Login from './components/admin/Login';


export default class App extends Component{
    render(){
        return(
            <div className="container">
                <Switch>
                    <Route path="/" exact component={Home} />
                    <Route path="/admin" component={Login} />
                </Switch>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/App.js